import pdfMake from "pdfmake/build/pdfmake";

let isInitialized = false;

export async function initializePdfMake() {
    if (isInitialized) {
        return; // Already initialized
    }

    const fonts = [
        'Courier',
        'Courier-Bold',
        'Courier-Oblique',
        'Courier-BoldOblique',
        'Helvetica',
        'Helvetica-Bold',
        'Helvetica-Oblique',
        'Helvetica-BoldOblique',
        'Times-Roman',
        'Times-Bold',
        'Times-Italic',
        'Times-BoldItalic',
        'Symbol',
        'ZapfDingbats'
    ];

    const vfs = {};

    // Load all AFM files
    await Promise.all(
        fonts. map(async (font) => {
            try {
                const response = await fetch(`/fonts/${font}.afm`);
                if (response.ok) {
                    const text = await response.text();
                    vfs[`data/${font}.afm`] = text;
                } else {
                    console.warn(`Could not load ${font}.afm: ${response.status}`);
                }
            } catch (error) {
                console.error(`Error loading ${font}.afm:`, error);
            }
        })
    );

    // Set VFS
    pdfMake.vfs = vfs;

    // Configure fonts
    pdfMake.fonts = {
        Courier: {
            normal: 'Courier',
            bold:  'Courier-Bold',
            italics: 'Courier-Oblique',
            bolditalics: 'Courier-BoldOblique'
        },
        Helvetica: {
            normal: 'Helvetica',
            bold: 'Helvetica-Bold',
            italics: 'Helvetica-Oblique',
            bolditalics: 'Helvetica-BoldOblique'
        },
        Times: {
            normal: 'Times-Roman',
            bold: 'Times-Bold',
            italics: 'Times-Italic',
            bolditalics: 'Times-BoldItalic'
        },
        Symbol: {
            normal: 'Symbol'
        },
        ZapfDingbats: {
            normal: 'ZapfDingbats'
        }
    };

    isInitialized = true;
    console.log('pdfMake initialized with AFM fonts');
}
